module.exports = __webpack_public_path__ + "static/media/goal-bimbim@2x.6401410e.png";